<template>
    <div class="print-dialog">
        <div class="hero print-header">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Printing {{ originalItems.length }} {{ originalItems.length | pluralize(type) }}
                        <div class="is-pulled-right has-text-right"
                             v-if="!showPrintConfirmation && originalItems.length >= 15">
                            <button class="button is-dark" @click="cleanup(false)"
                                    title="DOESN'T MARK AS PRINTED">
                                Cancel&nbsp;<i class="fa fa-close"></i>
                            </button>
                            <button type="button" class="button is-primary" @click="startPrint()">START</button>
                        </div>
                    </h1>
                    <small class="has-text-centered is-block" v-if="type === 'order' && originalItems.length >= 15">
                        Click <strong>START</strong> to begin printing the {{ originalItems.length }} {{
                        originalItems.length | pluralize(type) }}
                    </small>
                </div>
            </div>
        </div>
        <div class="print-container">
            <span v-if="type === 'order'">
                <order v-for="order in originalItems"
                       :key="order.id"
                       :order-id="order.id"
                       v-if="printItems.length === 0 || printItems.indexOf(order) !== -1"></order>
            </span>
            <div class="container" v-if="type === 'request'">
                <div class="title is-4 has-text-centered">
                    Catalog Requests - {{ $store.state.company.name }}
                </div>
                <table class="table is-fullwidth">
                    <thead>
                    <tr>
                        <th>Entered</th>
                        <th>Company</th>
                        <th>Referrer</th>
                        <th>Contact</th>
                        <th>Address</th>
                        <th>Requested</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="request in originalItems" :key="request.id"
                        v-if="printItems.length === 0 || printItems.indexOf(request) !== -1">
                        <td></td>
                        <td>{{ request.company }}</td>
                        <td>{{ request.referrer }}</td>
                        <td>
                            {{ request.first_name }} {{ request.last_name }}
                            <br v-if="request.email">
                            {{ request.email }}
                            <br v-if="request.phone">
                            {{ request.phone | phone }}
                        </td>
                        <td>
                            {{ request.line1 }}
                            <br v-if="request.line2">
                            {{ request.line2 }}
                            <br/>
                            {{ request.city }}, {{ request.state }} {{ request.zip }}
                            {{ request.country !== 'United States' ? request.country : '' }}
                        </td>
                        <td>
                            {{ request.created_at | moment('MM/DD/YY - h:mm A') }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="print-confirmation" v-if="showPrintConfirmation">
            <div class="print-confirmation-dialog" v-if="type === 'order'">
                <button class="button is-pulled-right is-danger" v-if="printSuccess === true" @click="cleanup(false)"
                        title="DON'T MARK ANYTHING AS PRINTED">
                    Cancel Print&nbsp;<i class="fa fa-close"></i>
                </button>
                <button class="button is-pulled-right" v-if="printSuccess === false" @click="printSuccess = true"
                        title="DON'T MARK ANYTHING AS PRINTED">Go Back</button>
                <h2 class="title">Print Confirmation</h2>
                <p class="has-text-centered title is-5" v-if="printSuccess === true">
                    Did all <b>{{ originalItems.length }}</b> {{ originalItems.length | pluralize('order') }} print?
                    <br/>
                    <br/>
                    <button class="button" @click="cleanup(true)">Yes, mark everything as printed.</button>
                    <button class="button" @click="printSuccess = false">No, some or all did not print.</button>
                </p>
                <div v-if="printSuccess === false">
                    <p class="has-text-centered">Select which orders did not print</p>
                    <div class="print-contents">
                        <div class="print-content" v-for="order in originalItems">
                            <label class="checkbox" :for="'order'+order.id" style="width: 100%;">
                                <input type="checkbox"
                                       :id="'order'+order.id"
                                       :value="order.id"
                                       :checked="printItems.indexOf(order) !== -1"
                                       @click="togglePrintItem(order)">
                                {{ order.company }} - {{ order.id }}
                            </label>
                        </div>
                    </div>
                    <button class="button" @click="selectAll()" v-if="printItems.length === 0">Select All</button>
                    <button class="button" @click="selectNone()" v-else>Deselect All</button>
                    <div class="is-pulled-right" v-if="printItems.length > 0">
                        <button class="button is-primary" @click="cleanup(false)">
                            Reprint the selected orders
                        </button>
                    </div>
                </div>
            </div>
            <div class="print-confirmation-dialog" v-if="type === 'request'">
                <h2 class="title">Print Confirmation</h2>
                <div class="has-text-centered">
                    <p>Click <strong>FINISH PRINT</strong> to mark the catalog requests as printed.</p>
                    <p>Click <strong>CANCEL PRINT</strong> to not mark anything as printed.</p>
                    <br/>
                </div>
                <div class="is-clearfix">
                    <button class="button is-pulled-left" @click="cleanup(false)"
                            title="DON'T MARK ANYTHING AS PRINTED">Cancel Print&nbsp; <i class="fa fa-close"></i>
                    </button>
                    <button class="button is-primary is-pulled-right" @click="cleanup(true)">
                        FINISH PRINT
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['type', 'contents'],
        data() {
            return {
                showPrintConfirmation: false,
                printItems: [],
                originalItems: [],
                printing: false,
                printSuccess: true,
            }
        },
        beforeMount() {
            let bodyEl = window.document.querySelector('body');
            bodyEl.classList.add('printing')
        },
        mounted() {
            this.originalItems = JSON.parse(JSON.stringify(this.contents))

            if (this.type === 'order') {
                let companies = [];
                for (let oindex in this.originalItems) {
                    let order = this.originalItems[oindex];
                    if (companies.indexOf(order.company) === -1) {
                        companies.push(order.company);
                    }
                }
                let sortedOrders = [];
                for (let x = 0; x < companies.length; x++) {
                    let company = companies[x];
                    for (let oi in this.originalItems) {
                        let ordera = this.originalItems[oi];
                        if (ordera.company === company) {
                            sortedOrders.push(ordera);
                        }
                    }
                }

                this.originalItems = JSON.parse(JSON.stringify(sortedOrders));
            }

            window.onafterprint = this.afterPrint
            let mediaQueryList  = window.matchMedia('print');
            mediaQueryList.addListener(function (mql) {
                if (!mql.matches) {
                    this.afterPrint()
                }
            }.bind(this));

            if (this.originalItems.length < 15) {
                setTimeout(this.startPrint, 500);
            }
        },
        beforeDestroy() {
            let bodyEl = window.document.querySelector('body');
            bodyEl.classList.remove('printing')
            window.onafterprint = null
        },
        methods: {
            startPrint() {
                window.print();
                this.printing = true;
            },
            afterPrint() {
                this.printing              = false;
                this.printItems            = []
                this.showPrintConfirmation = true
            },
            togglePrintItem(item) {
                let index = this.printItems.indexOf(item)
                if (index === -1) {
                    this.printItems.push(item)
                }
                else {
                    this.printItems.splice(index, 1)
                }
            },
            selectAll() {
                this.printItems = []
                for (let item in this.originalItems) {
                    if (this.originalItems.hasOwnProperty(item)) {
                        this.printItems.push(this.originalItems[item])
                    }
                }
            },
            selectNone() {
                this.printItems = []
            },
            cleanup(markAsPrinted = false) {
                if (this.printItems.length === 0) {
                    let check = markAsPrinted ? confirm('Are you absolutely sure?') : confirm('Are you sure? Nothing will be marked as printed.');
                    if(check) {
                        this.$bus.$emit('stopPrint', {
                            type: this.type,
                            contents: this.originalItems,
                            markAsPrinted: markAsPrinted
                        })
                    }
                }
                else {
                    window.print()
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// PrintDialog.vue?a7fde42c